import React, { Fragment, Component } from "react";
import Title from "./title";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getAllCourseReview } from "../../Graphs/CourseReview/listAllReviews";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { Spin, notification, Button } from "antd";
import CourseReviewRecordsTable from "./CourseREviewRecordsTable";

class CourseReview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reviews: [],
      isLoading: false,
      primaryColor: "#4466f2",
      envData: null,
    };
  }

  async componentDidMount() {
    try {
      const { setRouteName, setSearchText, course_id } = this.props;
      let editPrimaryColor = await localStorage.getItem("primary_color");

      let routeName = "FAQ";
      if (course_id) {
        routeName = "COURSE_FAQ";
      }

      await setRouteName(routeName);
      await setSearchText("");

      this.setState({
        isLoading: true,
        primaryColor: editPrimaryColor,
      });

      await this.listCourseReviewData();
    } catch (e) {
      notification["success"]({
        message: "Faq",
        description: "Somwthing went wrong",
      });
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  }

  listCourseReviewData = async () => {
    const {
      authToken,
      history,
      setLoginFlag,
      setUserData,
      setUserToken,
      setListCourseReviewData,
      setListCourseReviewDataTotal,
      course_id,
    } = this.props;

    try {
      let courseReviewData = await getAllCourseReview(
        authToken,
        0,
        10,
        course_id
      );

      if (courseReviewData.status === 200) {
        this.setState({
          reviews: courseReviewData.data,
        });
        await setListCourseReviewData(courseReviewData.data);
        await setListCourseReviewDataTotal(courseReviewData.total);

        this.setState({
          listCourseReviewData: courseReviewData.data,
          // faqList: faqData.data.FAQs.docs,
          listCourseReviewDataTotal: courseReviewData.total,
        });
      } else if (courseReviewData.status === 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (e) {
      throw e;
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };

  render() {
    const { isLoading } = this.state;
    const { course_id } = this.props;

    return (
      <Fragment>
        {!course_id ? <Title parent="Faq" title="faq" /> : null}

        <div className="container-fluid">
          {isLoading ? (
            <div style={{ marginLeft: "20px" }}>
              <Spin
                size="large"
                style={{ marginLeft: "480px", marginTop: "130px" }}
              />
            </div>
          ) : (
            <div>
              <CourseReviewRecordsTable
                listCourseReviewData={this.state.listCourseReviewData}
                primaryColor={this.state.primaryColor}
                listCourseReviewDataTotal={this.state.listCourseReviewDataTotal}
                course_id={course_id}
              />
            </div>
          )}
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.auth.authToken,
  listFaqData: state.faq.listFaqData,
  listFaqDataTotal: state.faq.listFaqDataTotal,
  loginUserData: state.auth.loginUserData,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setLoginFlag: (flag) => {
      dispatch({
        type: "SET_LOGIN_FLAG",
        flag: flag,
      });
    },
    setUserData: (userData) => {
      dispatch({
        type: "SET_USER_DATA",
        userData: userData,
      });
    },
    setUserToken: (authToken) => {
      dispatch({
        type: "SET_USER_AUTHTOKEN",
        authToken: authToken,
      });
    },
    setListCourseReviewData: (listCourseReviewData) => {
      dispatch({
        type: "SET_LIST_COURSE_REVIEW_DATA",
        listCourseReviewData: listCourseReviewData,
      });
    },
    setListCourseReviewDataTotal: (listCourseReviewDataTotal) => {
      dispatch({
        type: "SET_LIST_COURSE_REVIEW_DATA_TOTAL",
        listCourseReviewDataTotal: listCourseReviewDataTotal,
      });
    },
    setRouteName: (routeName) => {
      dispatch({
        type: "SET_ROUTE_NAME",
        routeName: routeName,
      });
    },
    setSearchText: (searchText) => {
      dispatch({
        type: "SET_SEARCH_TEXT",
        searchText: searchText,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CourseReview));
